module.exports = __webpack_public_path__ + "static/318408708_666023135194125_920671561452868595_n.jpg-1671186393225_512-c1b54cb131c76ff69016e5bd383f9c93.webp";